import { Trans, useTranslation } from 'react-i18next'
import { APPROACH_CARDS } from './constants'

export function ApproachValuesContent() {
  const { t } = useTranslation()

  return (
    <div className="bg-card px-6 py-4">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {APPROACH_CARDS.map(card => (
          <div
            key={card.titleKey}
            className={`${card.cardBg} flex min-h-[200px] flex-col rounded-2xl p-4`}
          >
            <div
              className={`${card.iconBg} mb-3 flex h-[30px] w-[30px] items-center justify-center rounded-full`}
            >
              <img
                src={card.icon}
                alt=""
                width={16}
                height={16}
                className="h-4 w-4 object-contain"
              />
            </div>
            <h3 className="text-foreground mb-2 text-base font-bold">{t(card.titleKey)}</h3>
            <div className="text-foreground text-sm leading-relaxed font-normal">
              {card.useTrans ? (
                <Trans
                  i18nKey={card.descriptionKey}
                  components={{ 1: <strong className="font-semibold" /> }}
                />
              ) : (
                t(card.descriptionKey)
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
